export const dropdownSizes = {
  default: 'default',
  small: 'small,',
};
